<template>
  <MainTemplate>
    <MainNavbar
      slot="header"
      is-back-arrow-enabled
      has-small-logo
    />

    <div class="w-100">
      <BaseLoading
        v-if="isRoundLoading && !round"
        full-screen
      />
      <div
        v-else
        class="pt-2"
      >
        <TheRoundInfoOverview :round="round" />
        <RoundDetailSummer
          v-if="round.season.league.type === 1"
          :round="round"
          :round-statuses="roundStatuses"
          :selected-athletes="selectedAthletes"
        />
        <RoundDetailClassic
          v-else
          :round="round"
          :round-statuses="roundStatuses"
          :selected-athletes="selectedAthletes"
          :is-athlete-assignment-processing="isAthleteAssignmentProcessing"
          @onAthletePick="handleAthletePick"
          @onAthletePickRemove="handleAthletePickRemove"
        />
      </div>
      <MainFooter />
    </div>
  </MainTemplate>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapActions, mapState } from 'vuex'
import { ROUND_STATUSES } from '@/store/modules/rounds'
import BaseLoading from '@/components/Atoms/BaseLoading'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainNavbar from '@/layout/MainNavbar'
import MainFooter from '@/layout/MainFooter'
import TheRoundInfoOverview from '@/components/Molecules/TheRoundInfoOverview'
import RoundDetailClassic from '@/pages/RoundDetail/Routes/Round/RoundDetailClassic'
import RoundDetailSummer from '@/pages/RoundDetail/Routes/Round/RoundDetailSummer'

export default {
  name: 'RoundDetail',
  components: {
    RoundDetailSummer,
    RoundDetailClassic,
    TheRoundInfoOverview,
    MainFooter,
    MainNavbar,
    MainTemplate,
    BaseLoading,
  },
  metaInfo() {
    return {
      title: this.$t('page-titles.round-detail'),
    }
  },
  data() {
    return {
      roundId: this.$route.params.roundId,
      roundStatuses: ROUND_STATUSES,
      isAthleteAssignmentProcessing: null,
    }
  },
  computed: {
    ...mapState({
      isRoundLoading: state => state['rounds/index'].isRoundLoading,
    }),
    round() {
      return this.$store.getters['rounds/index/getRoundById'](this.$route.params.roundId)
    },
    selectedAthletes() {
      return this.$store.getters['rounds/athletesInRound/getSelectedAthletesForRound'](this.roundId)
    },
  },
  created() {
    this.fetchRoundById({ roundId: this.roundId }).then((round) => {
      this.fetchSelectedAthletes({
        roundId: this.roundId,
      })
      // Only for summer round
      if (round.season.league.type === 1) {
        this.fetchRoundScorePredictions({
          roundId: this.roundId,
        })
        if (round.status === this.roundStatuses.closed) {
          this.fetchPrizes({
            roundId: this.roundId,
          })
          this.fetchScoreCounts({ roundId: this.round.id })
        }
        if (this.$route.name === 'round-pool-standings') {
          this.fetchRoundPoolStandings({
            roundId: this.roundId,
          })
        }
      }
    })
  },
  methods: {
    ...mapActions({
      fetchRoundById: 'rounds/index/fetchRoundById',
      fetchSelectedAthletes: 'rounds/athletesInRound/fetchSelectedAthletes',
      fetchRoundScorePredictions: 'rounds/summer/matchScore/fetchRoundScorePredictions',
      fetchRoundPoolStandings: 'rounds/summer/poolStandings/fetchRoundPoolStandings',
      fetchPrizes: 'prizes/index/fetchPrizes',
      fetchScoreCounts: 'rounds/scoreCounts/fetchScoreCounts',
      assignAthleteToRound: 'rounds/assignAthleteIntoRound/assignAthleteToRound',
      detachAthleteFromRound: 'rounds/assignAthleteIntoRound/detachAthleteFromRound',
      openTeamCompleteModal: 'profile/inviteUrl/openTeamCompleteModal',
      openSummerTeamCompleteModal: 'rounds/summer/predictionCompleted/openModal',
      incrementPredictionCount: 'auth/incrementPredictionCount',
    }),
    handleAthletePick(params) {
      this.isAthleteAssignmentProcessing = params.athleteId
      this.assignAthleteToRound(params).then(() => {
        setTimeout(() => {
          this.isAthleteAssignmentProcessing = null
          this.fetchSelectedAthletesForCurrentRound().then(() => {
            if (this.round.season.league.type === 'summer') {
              if (this.selectedAthletes.length === 1) {
                this.openSummerTeamCompleteModal({
                  roundId: this.round.id,
                })
                this.incrementPredictionCount()
                VueScrollTo.scrollTo('#content', 500, {
                  container: 'body',
                })
              }
            } else {
              if (this.selectedAthletes.length === 8) {
                this.openTeamCompleteModal({
                  roundId: this.round.id,
                })
                this.incrementPredictionCount()
                VueScrollTo.scrollTo('#content', 500, {
                  container: 'body',
                })
              }
            }
          })
        }, 500)
      })
    },
    handleAthletePickRemove(params) {
      this.isAthleteAssignmentProcessing = params.athleteId
      this.detachAthleteFromRound(params).then(() => {
        setTimeout(() => {
          this.isAthleteAssignmentProcessing = null
          this.fetchSelectedAthletesForCurrentRound()
        }, 500)
      })
    },
    fetchSelectedAthletesForCurrentRound() {
      return this.fetchSelectedAthletes({ roundId: this.roundId })
    },
  },
}
</script>
